import React from "react";
import { goToCheckout } from "../lib/checkout";
import { useCountdown, pad2 } from "../lib/countdown";

export default function FloatingBar() {
  const { hours, minutes, seconds } = useCountdown();
  // Combine hours into minutes for the mini display (timer never exceeds ~15 min anyway)
  const displayMinutes = hours * 60 + minutes;

  return (
    <div className="float-bar" role="complementary" aria-label="Sticky registration bar">
      <div className="max-w-7xl mx-auto px-3 md:px-5 py-3.5 md:py-4 flex items-center justify-between gap-3 md:gap-5">
        {/* Left: brand + subline */}
        <div className="min-w-0 flex-1 md:flex-none">
          <p className="text-white text-sm md:text-base font-extrabold leading-tight truncate">
            AI Money Machine System
            <span className="text-white/50 text-[0.6em] align-top ml-0.5">&trade;</span>
          </p>
          <p className="text-white/60 text-[11px] md:text-xs mt-0.5">
            Live workshop &middot;{" "}
            <span className="text-[#C4FF3D] font-bold">&#8377;199</span>{" "}
            <span className="hidden sm:inline text-white/45">&middot; Limited seats</span>
          </p>
        </div>

        {/* Center: mini countdown (hidden on mobile, visible on md+) */}
        <div className="hidden md:flex flex-col items-center leading-none shrink-0">
          <div className="flex items-center gap-1.5 mb-1.5">
            <span className="relative flex h-1.5 w-1.5">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75" />
              <span className="relative inline-flex rounded-full h-1.5 w-1.5 bg-red-500" />
            </span>
            <span className="text-red-400 text-[10px] uppercase tracking-[0.18em] font-bold">
              Closes In
            </span>
          </div>
          <div className="flex items-center gap-1">
            <TimerCell value={displayMinutes} />
            <span className="text-[#C4FF3D]/60 display-font font-extrabold text-base">:</span>
            <TimerCell value={seconds} />
          </div>
        </div>

        {/* Right: CTA */}
        <button
          type="button"
          onClick={() => goToCheckout("sticky_bar")}
          className="cta-pulse shrink-0 inline-flex items-center gap-2 px-4 md:px-6 py-3 md:py-3.5 rounded-full bg-[#C4FF3D] text-[#0a0f0a] text-xs md:text-sm font-extrabold hover:bg-[#d4ff5c] transition"
        >
          <span>RESERVE MY SEAT</span>
          <span className="font-black">&rarr;</span>
        </button>
      </div>
    </div>
  );
}

function TimerCell({ value }) {
  return (
    <span className="inline-flex items-center justify-center min-w-[28px] px-1.5 py-1 rounded-md bg-[#0a0f0a] border border-[rgba(196,255,61,0.3)] display-font font-extrabold text-[#C4FF3D] text-base tabular-nums">
      {pad2(value)}
    </span>
  );
}
